import React, { useEffect, useState } from "react";
import { Card } from "components";
import { Box, Heading, Spacer, VStack } from "@chakra-ui/layout";
import Category from "./Category";
import { FreeResponseText } from "components";
import { useAssessmentContext } from "hooks/assessment";

interface CategoryGroup {
  fields: any;
}

const ConversationContainer: React.FC = ({ children }) => {
  return (
    <div
      style={{
        /* height: "400px", */
        width: "auto",
        overflowY: "auto",
        overflowX: "hidden"
      }}
    >
      {children}
    </div>
  );
};

const Conversation: React.FC<{ conversationNumber: number, categories: Array<CategoryGroup>, componentHeight: number, toggleGameLiftStreamsInput: any }> = ({ conversationNumber, categories, componentHeight, toggleGameLiftStreamsInput }) => {
  const { getValue, saveDataResponse } = useAssessmentContext();
  const [initData, setInitData] = useState<string>("");
  const formattedConversationNumber = "[" + conversationNumber + "]";

  //going to need this block to load in notes
  const getCachedValue = async (tags: string[]) => {
    // if/when we change to relational db schema, call the api directly from here
    // to retrieve the value stored in db
    return getValue(tags);
  };

  const handleTextChange = (tags: string[], textValue: string) => {
    // Do NOT setInitState, as that will re-render the
    // NullableCheckbox Component
    //setInitState(checkboxValue);

    // if/when we change to relational db schema, call the api directly from here
    // to update the value
    saveDataResponse(tags, textValue);
  };

  useEffect(() => {
    getCachedValue([formattedConversationNumber, "notes"])
      .then(initialValue => {
        setInitData(initialValue.data);
      });
  }, []);

  return (
    <Card width="100%" height={componentHeight}
      display="block"
    >
      <Box
        height="100%"
        minHeight="0px"
        minWidth="0px"
        style={{
          overflowY: "scroll",
          overflowX: "hidden",
          scrollbarWidth: "thin"
        }}
      >
        <VStack align="left">
          <Heading fontSize="20px" fontWeight="700" color="#FFFFFF">
            Social Constructs & Competencies
          </Heading>
          <Spacer />
          <Heading fontSize="13px" fontWeight="300" color="E5E5E5">
            Does the client consistently demonstrate competency in...
          </Heading>
          <ConversationContainer>
            {categories.map((categoryContent: any) => (
              <Category
                title={categoryContent.fields.categoryName}
                childContent={categoryContent.fields.subtopics}
                tags={[formattedConversationNumber, categoryContent.fields.tag]}
                toggleGameLiftStreamsInput={toggleGameLiftStreamsInput}
              />
            ))}
          </ConversationContainer>
          <FreeResponseText
            messageBody={initData} //TODO replace this, maybe with messageBody
            onMessageBodyChange={() => { }} //TODO replace this, maybe with setMessageBody
            saveMessage={(textValue: string) => handleTextChange([formattedConversationNumber, "notes"], textValue)} //TODO replace this, maybe with saveResponse
            toggleGameLiftStreamsInput={toggleGameLiftStreamsInput}
          />
        </VStack>
      </Box>
    </Card>
  );
};

export default Conversation;
